import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/books`;

// * Route configuration object for books-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const booksRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:bookId`,
  edit: `${baseRoute}/edit/:bookId`,
} as const;

// ! these are breadcrumbs translation not page title
const booksRouteTranslation: IRouteTranslation<typeof booksRoutesObj> = {
  list: "booksList",
  create: "addBook",
  edit: "editBook",
  view: "viewBook",
};

// * Extracts the route parameters for the books route configuration.
export type IBooksRouteParams = IExtractRouteParamMap<typeof booksRoutesObj>;

// * Path functions for the books routes.
export const booksPath = createPaths<typeof booksRoutesObj, IBooksRouteParams>(
  booksRoutesObj,
);

// * Breadcrumbs {translation and route} for the faculty routes
export const booksBreadcrumbs = createBreadcrumbObject<typeof booksRoutesObj>(
  booksRoutesObj,
  booksRouteTranslation,
);
rebase(booksBreadcrumbs, "list");
